import { router } from '../router.ts';

export class ErrorPage {
  private root: HTMLElement;
  private reason: string;

  constructor(root: HTMLElement, reason?: string) {
    this.root = root;
    this.reason = reason ?? '문제가 발생했습니다';
  }

  mount(): void {
    this.render();
  }

  unmount(): void {}

  private render(): void {
    this.root.innerHTML = '';
    const el = document.createElement('main');
    el.className = 'min-h-screen safe-x safe-y flex flex-col items-center justify-center';
    el.style.setProperty('--page-pad-x', '1.5rem');
    el.style.setProperty('--page-pad-y', '1.5rem');
    const inner = document.createElement('div');
    inner.className = 'w-full max-w-md flex flex-col items-center gap-6';
    el.appendChild(inner);
    inner.innerHTML = `
      <div class="text-5xl">⚠</div>
      <h1 class="text-2xl font-bold text-wood-ink">오류</h1>
      <p class="text-wood-coffee text-center">${escapeHtml(this.reason)}</p>
      <button
        type="button"
        data-role="home"
        class="rounded-xl bg-card-navy hover:bg-card-deep text-card-gold py-3 px-6 font-semibold"
      >메인으로 돌아가기</button>
    `;
    this.root.appendChild(el);

    el.querySelector<HTMLButtonElement>('[data-role="home"]')?.addEventListener('click', () =>
      router.navigate({ name: 'main' }),
    );
  }
}

function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
